<template>
  <div>
    <zoom-info-form
      title="zoom_meeting.add_new_zoom_meeting"
      @submitForm="submitForm"
    ></zoom-info-form>
  </div>
</template>
<script>
import ZoomInfoForm from "./Components/ZoomInfoForm";
import { service_paths, service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { zoom_meeting_names } from "@/routes/routes";

export default {
  components: { ZoomInfoForm },
  methods: {
    submitForm(form) {
      let path = `${service_names.school}/zoom-meeting/recurring-meeting`;
      if (form.zoom_meeting_type === "A schedule meeting") {
        path = `${service_names.school}/zoom-meeting/scheduled-meeting`;
      }
      this.$axios.post(path, form).then(() => {
        Message.success(this.$t("common.add_success"));
        this.$router.push({ name: zoom_meeting_names.listPage });
      });
    }
  }
};
</script>
